export default __webpack_public_path__ + "static/media/app-logo.52558b4f.svg";